(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DrugDialogController', DrugDialogController);

    DrugDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Drug'];

    function DrugDialogController ($timeout, $scope, $uibModalInstance, entity, Drug) {
        var vm = this;

        vm.drug = entity;
        vm.datePickerOpenStatus = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        vm.dateOptions = {
            maxDate: new Date() + 1
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.drug.id !== null) {
                Drug.update(vm.drug, onSaveSuccess, onSaveError);
            } else {
                Drug.save(vm.drug, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:drugUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
